import BattlePreviewCard from "./BattlePreviewCard";
import { FetchError } from "../errors/FetchError";
import "../App.css";

export default function BattleHistory({ history, hasMore, loadingMore, onLoadMore, loadMoreError }) {
  if (history.length === 0) {
    return (
      <div className="history-empty">
        <p className="history-empty-text">No battles yet. Start fighting!</p>
      </div>
    );
  }

  return (
    <div className="history-section">
      <div className="battle-cards-grid">
        {history.map((h) => (
          <BattlePreviewCard key={h.id} {...h} />
        ))}
      </div>
      {loadMoreError ? (
        <div className="load-more-wrap">
          <FetchError message="Couldn't load more battles." onRetry={onLoadMore} />
        </div>
      ) : hasMore && (
        <div className="load-more-wrap">
          <button className="regen-btn" onClick={onLoadMore} disabled={loadingMore}>
            {loadingMore ? "Loading…" : "Load more"}
          </button>
        </div>
      )}
    </div>
  );
}
